// extracted by mini-css-extract-plugin
export default {"discount-slab-report-container":"DiscountSlabReport_discount-slab-report-container__ryNt1"};